import React from "react";
import Footer from "../../components/footer/Footer";
import Header from "../../components/header/Header";
import useIbenda from "../../hooks/useIbenda";
import IbendaComponent from "./IbendaComponent";

const PrivacyPolicy = () => {
  const { isLoading } = useIbenda();

  return (
    <div>
      <Header />
      <div className="tf-connect-wallet tf-section privacy-policy-header">
        {!isLoading && (
          <IbendaComponent
            title={"Privacy Policy"}
            id={"privacy-policy/87038604"}
          />
        )}
      </div>
      <Footer />
    </div>
  );
};

export default PrivacyPolicy;
